import { memo } from 'react';
import SectionLayout from 'components/common/SectionLayout';
import { Typography } from '@mui/material';
import { AddNewAppBtn, ChangeApp } from 'components';
import { campaignEnvironment } from 'constants';
import { ErrorMarker } from 'assets/icons';
import SelectedApp from './SelectedApp';

import * as S from './ChooseAppOrWebsite.styled';

const ChooseAppOrWebsite = ({
  title,
  errorMessage,
  isWebsite,
  environment,
  canChange,
  errorFlag,
  appToPromote,
  handleChooseApp,
  selectedAppFromBase,
}) => {
  return (
    <SectionLayout
      topPadding='8'
      leftSide={
        <Typography variant='subtitle2' component='h6'>
          {title}
        </Typography>
      }
      rightSide={
        <S.Content>
          <S.AppContainer showBorder={errorFlag}>
            {canChange && (
              <S.ButtonsRow style={{ marginBottom: appToPromote ? '16px' : '' }}>
                <ChangeApp isWebsite={isWebsite} />
                <S.OrSeperator>OR</S.OrSeperator>
                <AddNewAppBtn.CampaignPage chooseAction={handleChooseApp} isWebsite={isWebsite} />
              </S.ButtonsRow>
            )}
            {appToPromote && environment === campaignEnvironment.new_empty && (
              <SelectedApp environment={environment} {...appToPromote} key='new_empty' />
            )}

            {(environment === campaignEnvironment.edit ||
              environment === campaignEnvironment.duplicate) && (
              <SelectedApp
                environment={environment}
                {...selectedAppFromBase}
                key='editOrDuplicate'
              />
            )}
          </S.AppContainer>
          {errorFlag && (
            <S.ErrorWrap>
              <ErrorMarker />
              <span>{errorMessage}</span>
            </S.ErrorWrap>
          )}
        </S.Content>
      }
    />
  );
};

export default memo(ChooseAppOrWebsite);
